module.exports = __webpack_public_path__ + "static/media/arrow.95b4190c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/arrow.svg
// module id = 1627
// module chunks = 71